import { render, staticRenderFns } from "./DeviceDetails.vue?vue&type=template&id=bbfa2cfa&scoped=true&"
import script from "./DeviceDetails.vue?vue&type=script&lang=js&"
export * from "./DeviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetails.vue?vue&type=style&index=0&id=bbfa2cfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfa2cfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbfa2cfa')) {
      api.createRecord('bbfa2cfa', component.options)
    } else {
      api.reload('bbfa2cfa', component.options)
    }
    module.hot.accept("./DeviceDetails.vue?vue&type=template&id=bbfa2cfa&scoped=true&", function () {
      api.rerender('bbfa2cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/DeviceDetails.vue"
export default component.exports